<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Restocking'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-row>
      <tidy-text
        [header]="'Add Items to Restock'" />
    </tidy-row>

    <tidy-row class="extra-bottom-padding">
      <tidy-text
        [body]="'We started with a list of most popular items. Add or remove items as needed.'" />
    </tidy-row>

    @if (!loaded) {
      <ion-skeleton-text animated="true" style="width: 100%; height: 210px" />
    }

    @for (item of addedItems; track item; let i = $index) {
      <div>
        <tidy-row [alignLastItemRight]="true">
          <tidy-image
            [src]="item.icon || 'https://d30thx9uw6scot.cloudfront.net/svgs/stove.svg'"
            class="header-size" />
          <tidy-text [body]="item.name" />
          @if (item.current || item.min || item.max) {
            <span>&nbsp;</span>
          }
          @if (item.current || item.min || item.max) {
            <tidy-text [body]="'('" />
          }
          @if (item.current) {
            <tidy-text [body]="'Current:'" />
          }
          @if (item.current) {
            <span>&nbsp;</span>
          }
          @if (item.current) {
            <tidy-text [body]="item.current" />
          }
          @if (item.min) {
            <span>&nbsp;</span>
          }
          @if (item.min) {
            <tidy-text [body]="'/ Min:'" />
          }
          @if (item.min) {
            <span>&nbsp;</span>
          }
          @if (item.min) {
            <tidy-text [body]="item.min" />
          }
          @if (item.max) {
            <span>&nbsp;</span>
          }
          @if (item.max) {
            <tidy-text [body]="'/ Max:'" />
          }
          @if (item.max) {
            <span>&nbsp;</span>
          }
          @if (item.max) {
            <tidy-text [body]="item.max" />
          }
          @if (item.current || item.min || item.max) {
            <tidy-text [body]="')'" />
          }
          <div>
            <tidy-image
              (action)="removeItem(item)"
              [src]="'assets/svg/close-outline.svg'"
              class="body-size" />
          </div>
        </tidy-row>
      </div>
    }

    <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
      <tidy-text
        [header]="'Add New Item'" />
      <tidy-text
        [actionBody]="'+ Add Item'"
        class="link"
        (action)="addItem()" />
    </tidy-row>

    <tidy-row>
      <form [formGroup]="itemForm" action="#">
        <tidy-select
          [label]="'Item Name'"
          [items]="categoryItems"
          [multiple]="false"
          [form]="itemForm.controls.itemName"
          formControlName="itemName"
          [submitted]="submitted"
          (optionChange)="selectItemName($event)" />
      </form>
    </tidy-row>

    <tidy-row class="extra-bottom-padding">
      <form [formGroup]="itemForm" action="#">
        <tidy-three-column-row>
          <tidy-input
            [label]="'Current #'"
            formControlName="current"
            [form]="itemForm.controls.current"
            [inputMode]="'numeric'" />
          <tidy-input
            [label]="'Min #'"
            formControlName="min"
            [form]="itemForm.controls.min"
            [inputMode]="'numeric'" />
          <tidy-input
            [label]="'Max #'"
            formControlName="max"
            [form]="itemForm.controls.max"
            [inputMode]="'numeric'" />
        </tidy-three-column-row>
      </form>
    </tidy-row>

    <tidy-row class="extra-top-padding">
      <tidy-text
        [header]="'Where do you typically like to order things?'" />
    </tidy-row>

    <tidy-row>
      <form [formGroup]="form">
        <tidy-input
          [label]="'eg: Amazon, Walmart, etc.'"
          formControlName="whereToOrder"
          [form]="form.controls.whereToOrder" />
      </form>
    </tidy-row>

    <tidy-row class="extra-top-padding">
      <tidy-text
        [header]="'Where do you want them to be shipped?'" />
    </tidy-row>

    <tidy-row class="extra-bottom-padding">
      <form [formGroup]="form">
        <tidy-input
          [label]="'eg: My central office, the property.'"
          formControlName="whereToShip"
          [form]="form.controls.whereToShip" />
      </form>
    </tidy-row>

    <tidy-button
      [text]="'Save Items'"
      [action]="boundSaveItems"
      class="primary" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
